import api from '@/services/api'

export default {
  getAll() {
    return api.get('/banners')
  },

  update(data) {
    return api.put(`/banners/${data._id }`, data);
  },

  remove(id) {
    return api.delete(`/banners/${id }`);
  },

  sort(data) {
    return api.put('/banners/sort', data);
  },

  uploadBanner(formData) {
    return api.post('/banners/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  uploadWebBanner(bannerId, formData) {
    return api.post('/banners/upload-web/' + bannerId, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
}